import { connect } from 'react-redux';
import ConfirmDeleteModal from './shared/confirm_delete_modal.jsx';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  deleteSubpage
} from 'zoomforth_codesbane_editor/action_creators/subpage.js';

import {
  closeMenuItemEditor
} from 'zoomforth_codesbane_editor/action_creators/navigation.js';

import { get as getPageHistoryTracker } from 'zoomforth_zf/appglobals/page-history-tracker.js';

const mapStateToProps = (state, { subpageTitle }) => {
  return {
    title: 'Really delete subpage?',
    body: `You are about to delete the subpage "${subpageTitle}". 
      This will delete all of the content in this subpage. This cannot be undone.`,
    confirmText: 'Delete Subpage',
    cancelText: 'Cancel'
  };
};


const mapDispatchToProps = (dispatch, { subpage, subpageTitle }) => (
  {
    onCancel: ()=> { 
      dispatch(closeModal()); 
    },
    onConfirm: ()=> { 
      getPageHistoryTracker().trackDeleteSubpage(subpageTitle);
      dispatch(deleteSubpage(subpage));
      dispatch(closeMenuItemEditor());
      dispatch(closeModal());
    }
  }
);

const ConfirmDeleteSubpageModal = connect(
  mapStateToProps,
  mapDispatchToProps

)(ConfirmDeleteModal);

ConfirmDeleteSubpageModal.editorModalName = 'ConfirmDeleteSubpageModal';

export default ConfirmDeleteSubpageModal;